import React, { useState } from "react";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { FilePdf, DownloadSimple, CircleNotch } from "@phosphor-icons/react";
import { downloadCalendar } from "@/lib/api";

export const getCalendar = async () => {
  const blob = await downloadCalendar();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Franchise-Expo-Calendar.pdf";
  a.click();
  URL.revokeObjectURL(url);
  toast.success("Calendar downloaded — a copy is on its way to your inbox");
};

export const LeadMagnet = ({ verified, onNeedVerify, total }) => {
  const [busy, setBusy] = useState(false);

  const handle = async () => {
    if (!verified) return onNeedVerify();
    setBusy(true);
    try {
      await getCalendar();
    } catch {
      toast.error("Couldn't prepare the calendar. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mx-auto max-w-7xl px-5 pt-14 sm:px-8" data-testid="lead-magnet">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.45 }}
        className="relative flex flex-col gap-6 overflow-hidden rounded-3xl border border-blue-500/25 bg-[#0f1a3a]/60 p-7 sm:flex-row sm:items-center sm:justify-between sm:p-9"
      >
        <div className="pointer-events-none absolute -left-20 -top-20 h-56 w-56 rounded-full bg-blue-500/15 blur-3xl" />
        <div className="relative flex items-start gap-5">
          <div className="hidden h-20 w-16 shrink-0 -rotate-6 flex-col items-center justify-center rounded-lg border border-white/15 bg-white text-[#0B0D17] shadow-xl sm:flex">
            <FilePdf size={30} weight="fill" className="text-red-500" />
            <span className="mt-1 text-[9px] font-bold uppercase tracking-wider">2026–27</span>
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.16em] text-blue-300">Free download</span>
            <h2 className="mt-1.5 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
              Franchise Expo Calendar 2026–27
            </h2>
            <p className="mt-2 max-w-xl text-sm text-slate-400">
              All {total || "upcoming"} franchise &amp; licensing shows on one printable PDF — dates, cities, venues and categories,
              month by month. We'll email you a copy too.
            </p>
          </div>
        </div>
        <button
          data-testid="lead-magnet-download-btn"
          onClick={handle}
          disabled={busy}
          className="relative inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-blue-500 disabled:opacity-70"
        >
          {busy ? <CircleNotch size={17} className="animate-spin" /> : <DownloadSimple size={17} weight="bold" />}
          {verified ? "Download the PDF" : "Get the free PDF"}
        </button>
      </motion.div>
    </section>
  );
};
